/**
 * @page security store
 * @author
 * @Date 2018/7/2
 */

import { observable, action, configure, makeAutoObservable } from 'mobx';

import { CodeFrom } from '../components/CodeBox';
import verifyService from '../service/verifyService';

configure({
  enforceActions: 'always',
});

export default class verifyStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      verifyType: observable,
      verifyTypeNumber: observable,
      verifyData: observable,
      email: observable,
      phone: observable,
      canSwitchGoogleSms: observable,
      canSwitchSmsVoice: observable,
      valueClean: observable,
      errorClean: observable,
      initStore: action,
      onValueCleaned: action,
      onErrorCleaned: action,
      onChange: action,
      sendEmailCode: action,
      sendSmsCode: action,
      sendVoiceCode: action,
      openSwitchGoogleSms: action,
      switchGoogleSms: action,
      switchGoogleVoice: action,
      openSwitchSmsVoice: action,
      switchSmsVoice: action,
      closeSwitchGoogleSms: action,
      setVerifyType: action,
      dealVerifyType: action,
    });

    this.rootStore = rootStore;
  }

  // 验证码类型
  verifyType = {
    google: false,
    sms: false,
    email: false,
    voice: false,
    onlyNeedLoginPWD: false,
  };

  // 验证码类型
  verifyData = {
    googleCode: '',
    smsCode: '',
    emailCode: '',
    allow: false,
  };

  // 邮箱
  email = '';
  // 手机号
  phone = '';

  // 谷歌短信切换标志
  canSwitchGoogleSms = false;
  // 短信语音切换标志
  canSwitchSmsVoice = true;

  // 值清除
  valueClean = {
    google: false,
    sms: false,
    email: false,
    voice: false,
  };

  // 错误清除
  errorClean = {
    google: false,
    sms: false,
    email: false,
    voice: false,
  };

  verifyTypeNumber = 0;

  initStore() {
    this.verifyType = {
      google: false,
      sms: false,
      email: false,
      voice: false,
      onlyNeedLoginPWD: false,
    };
    this.verifyData = {
      googleCode: '',
      smsCode: '',
      emailCode: '',
      allow: false,
    };
    // 邮箱
    this.email = '';
    // 手机号
    this.phone = '';

    // 谷歌短信切换标志
    this.canSwitchGoogleSms = false;
    // 短信语音切换标志
    this.canSwitchSmsVoice = true;

    // 值清除
    this.valueClean = {
      google: false,
      sms: false,
      email: false,
      voice: false,
    };
    // 错误清除
    this.errorClean = {
      google: false,
      sms: false,
      email: false,
      voice: false,
    };
  }

  onValueCleaned() {
    this.valueClean = {
      google: false,
      sms: false,
      email: false,
      voice: false,
    };
  }

  onErrorCleaned() {
    this.errorClean = {
      google: false,
      sms: false,
      email: false,
      voice: false,
    };
  }

  onChange(verifyData) {
    this.verifyData = verifyData;
  }

  // 发送邮箱验证码
  sendEmailCode(type, params, successCb, errorCb, noAuth) {
    if (type === CodeFrom.security) {
      verifyService
        .sendEmail_Users(params, noAuth)
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    } else if (type === CodeFrom.withdraw) {
      verifyService
        .sendEmail_Wallet(Object.assign(params, { isWithdrawal: 1 }))
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    } else if (type === CodeFrom.address) {
      verifyService
        .sendEmail_Wallet(Object.assign(params, { isWithdrawal: 0 }))
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    }
  }

  // 发送短信验证码
  sendSmsCode(type, params, successCb, errorCb, noAuth) {
    if (type === CodeFrom.security) {
      verifyService
        .sendSms_Users(params, noAuth)
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    } else if (type === CodeFrom.withdraw) {
      verifyService
        .sendSms_Wallet(
          Object.assign(params, {
            isVoice: false,
            isWithdrawal: 1,
          })
        )
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    } else if (type === CodeFrom.address) {
      verifyService
        .sendSms_Wallet(
          Object.assign(params, {
            isVoice: false,
            isWithdrawal: 0,
          })
        )
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    } else if (type === CodeFrom.asset) {
      // 安全中心 用户限额使用
      verifyService
        .sendSms_Asset()
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    }
  }

  // 发送语音验证码
  sendVoiceCode(type, params, successCb, errorCb, noAuth) {
    if (type === CodeFrom.security) {
      verifyService
        .sendVoice_Users(params, noAuth)
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    } else if (type === CodeFrom.withdraw) {
      verifyService
        .sendSms_Wallet(
          Object.assign(params, {
            isVoice: true,
            isWithdrawal: 1,
          })
        )
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    } else if (type === CodeFrom.address) {
      verifyService
        .sendSms_Wallet(
          Object.assign(params, {
            isVoice: true,
            isWithdrawal: 0,
          })
        )
        .then((res) => {
          successCb(res);
        })
        .catch((res) => {
          errorCb(res);
        });
    }
  }

  /** 以下对外暴露方法** */

  // 开启谷歌短信切换
  openSwitchGoogleSms() {
    this.canSwitchGoogleSms = true;
  }

  // 谷歌短信切换
  switchGoogleSms() {
    this.verifyType.google = !this.verifyType.google;
    this.verifyType.sms = !this.verifyType.sms;

    if (this.verifyType.google) {
      this.valueClean.google = true;
      this.errorClean.google = true;
    }
    if (this.verifyType.sms) {
      this.valueClean.sms = true;
      this.errorClean.sms = true;
    }
  }

  // 谷歌语音切换
  switchGoogleVoice() {
    this.verifyType.voice = !this.verifyType.voice;
    this.verifyType.google = !this.verifyType.google;

    if (this.verifyType.google) {
      this.valueClean.google = true;
      this.errorClean.google = true;
    }
    if (this.verifyType.voice) {
      this.valueClean.voice = true;
      this.errorClean.voice = true;
    }
  }

  // 开启短信语音切换
  openSwitchSmsVoice() {
    this.canSwitchSmsVoice = true;
  }

  // 短信语音切换
  switchSmsVoice() {
    this.verifyType.voice = !this.verifyType.voice;
    this.verifyType.sms = !this.verifyType.sms;

    if (this.verifyType.sms) {
      this.valueClean.sms = true;
      this.errorClean.sms = true;
    }
    if (this.verifyType.voice) {
      this.valueClean.voice = true;
      this.errorClean.voice = true;
    }
  }

  // 关闭切换谷歌短信切换
  closeSwitchGoogleSms() {
    this.canSwitchGoogleSms = false;
  }

  // 设置验证类型  资金使用
  setVerifyType(verifyType) {
    const { sms, email, google } = verifyType;

    if (!sms) {
      this.valueClean.sms = true;
      this.errorClean.sms = true;
    }
    if (!email) {
      this.valueClean.email = true;
      this.errorClean.email = true;
    }
    if (!google) {
      this.valueClean.google = true;
      this.errorClean.google = true;
    }

    this.verifyType = verifyType;
    this.verifyType.voice = false;
  }

  // 处理验证类型类型 个人中心使用
  dealVerifyType(t) {
    const type = Number(t);
    this.verifyType = {
      google: type === 0 || type === 3 || type === 4 || type === 6,
      sms: type === 1 || type === 3 || type === 5 || type === 6,
      email: type === 2 || type === 4 || type === 5 || type === 6,
      onlyNeedLoginPWD: type === 7,
      voice: false,
    };
    this.verifyTypeNumber = type;
  }
}
